<template>
    <!-- <v-layout row wrap> -->
      <!-- from date selection -->
      <div style="display: flex;" >
        <!-- Date Picker -->
        <v-menu
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="date"
              :label="params.dateLabel" 
              prepend-icon="mdi-calendar"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date" @input="sendDatesToParent" :min="params.defaultTime"></v-date-picker>
        </v-menu>
        <v-menu
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          v-if="params.timePicker"
        >
        <template v-slot:activator="{ on }">
            <v-text-field
              v-model="time"
              :label="params.timeLable" 
              prepend-icon="mdi-calendar"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-time-picker v-model="time" @input="sendDatesToParent" ></v-time-picker>
        </v-menu>
      </div>
    <!-- </v-layout> -->
  </template>
  
  <script>
  export default {
    props: ["params"],
    data: () => ({
      date: "",
      time:"00:00"
    }),
    mounted(){
      this.date = this.params.defaultTime
    },
    methods: { 
      sendDatesToParent() {
        // Emit the custom event with the selected dates
        this.$emit("datesSelected", {
          from: this.params.from,
          date: this.date+" "+this.time,
        }); 
        console.log("selected datetime -->>",this.date+this.time)
      },
    },
  };
  </script>